type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Called each time `confirmPoint` closes a rally. Only a confirmed point: a score
 * jump, an undo or a resumed match never go through it.
 */
export function onPointConfirmed(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyPointConfirmed(): void {
  listeners.forEach((listener) => {
    // A listener (vibration) must never break live entry.
    try {
      listener();
    } catch {
      // Ignored.
    }
  });
}
